
import { validationMixin } from 'vuelidate'
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { required, maxLength } from 'vuelidate/lib/validators'
import { COPY_PRODUCT_PACKAGE } from './ProjectProductPackagesMutations'
import { copyProductPackage, copyProductPackageVariables } from './__generated__/copyProductPackage'
import { ProductPackageListDocument } from '@/views/productPackageListView/gql/__generated__/GetProductPackageList.query'

@Component({
  mixins: [validationMixin]
})
export default class CopyProductPackageDialog extends Vue {
  @Prop({ default: false }) show!: boolean
  @Prop({ default: () => [] }) existingProductPackageNames!: string[]
  @Prop() readonly productPackageId!: string
  @Prop() productPackageName!: string

  isSaving = false
  name = ''

  @Watch('show')
  onVisibilityChange() {
    this.name = this.productPackageName || ''
  }

  get showLoader() {
    return this.$apollo.loading || this.isSaving
  }

  clickClose() {
    this.$v.$reset()
    this.name = ''
    this.$emit('close')
  }

  clickSave() {
    this.$v.$touch()
    if (this.$v.name.$pending || this.$v.name.$error) return

    this.isSaving = true

    this.$apolloMutate<copyProductPackage, copyProductPackageVariables>({
      mutation: COPY_PRODUCT_PACKAGE,
      variables: {
        productPackageId: this.productPackageId,
        productPackageName: this.name
      },
      refetchQueries: [
        {
          query: ProductPackageListDocument
        }
      ],
      error: 'E4198'
    })
      .then((result) => {
        if (result !== false) {
          this.clickClose()
        }
      })
      .finally(() => (this.isSaving = false))
  }

  validations() {
    return {
      name: {
        required,
        maxLength: maxLength(50),
        isUnique: (value: string) => {
          return !this.existingProductPackageNames.includes(value)
        }
      }
    }
  }

  get nameErrors() {
    const errors = new Array<string>()
    if (!this.$v.name.$dirty) {
      return errors
    }
    if (!this.$v.name.isUnique) {
      errors.push(this.$t('productPackage.copy.errors.name.isUnique').toString())
    }
    if (!this.$v.name.maxLength) {
      errors.push(this.$t('productPackage.copy.errors.name.maxLength').toString())
    }
    if (!this.$v.name.required) {
      errors.push(this.$t('productPackage.copy.errors.name.required').toString())
    }
    return errors
  }
}
